import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getTeacherAssessmentThunk = createAsyncThunk(
  "assessment/getteacherallassessment",
  async (params) => {
    const { language, usertype, type, categoryId } = params;
    let response = await api.get(
      "getteacherallassessment/" +
        type +
        "/" +
        "od" +
        "/" +
        categoryId +
        "/" +
        usertype
    );
    return response.data;
  }
);

export const getcategoryThunk = createAsyncThunk(
  "assessment/getAllTchBaselineCategories",
  async (usertype) => {
    let response = await api.get("getAllTchBaselineCategories/" + usertype);
    return response.data;
  }
);

export const createTeacherAssessmentThunk = createAsyncThunk(
  "assessment/create",
  async (body) => {
    let response = await api.post("createteacherassessment", body);
    return response.data;
  }
);

export const updateTeacherAssessmentThunk = createAsyncThunk(
  "assessment/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body
    let response = await api.put("updateteacherassessment/" + id, body);
    return response.data;
  }
);

export const deleteTeacherAssessmentThunk = createAsyncThunk(
  "assessment/delete",
  async (id) => {
    let response = await api.delete("deleteteacherassessment/" + id);
    return response.data;
  }
);
